import { useMediaLayerHold } from './MediaLayers';

/**
 * A picture enlarged and blurred to fill its box: the ground a picture that doesn't fill the box
 * sits on (a media dialog's scene, a card's picture area). Pass it as a `MediaLayers` layer's
 * `under`: the layer waits for it.
 */
export function MediaBackdrop({ src }: { src: string }) {
  const release = useMediaLayerHold();
  return (
    // `data-media-backdrop`: part of the picture for the ones dimming it (a tile on hover)
    <div
      aria-hidden
      data-media-backdrop=""
      className="absolute inset-0 overflow-hidden"
    >
      <img
        src={src}
        alt=""
        onLoad={release}
        onError={release}
        className="absolute inset-0 size-full scale-[1.6] object-cover opacity-70 blur-3xl saturate-150"
      />
      <span className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/40" />
    </div>
  );
}
